let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6IBHL")).then(() => parcelRequire('8XGHT'));